import { useMutation, useQueryClient } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IUpdateInboundPackageResponseRaw } from '../../../types';

import { PACKAGE_DETAILS_QUERY_KEY } from '../../inventory';

import { INBOUND_HISTORY_LIST_KEY } from './useInboundHistoryListQuery';

/**
 * This is to track the update Inbound package details mutation keys in react query cache.
 */
const MUTATE_UPDATE_INBOUND_PACKAGE = 'update-inbound-package-mutation-key';

interface IUseManageCreateOrUpdateMutation {
  onSuccessCallback?: (data: IUpdateInboundPackageResponseRaw) => void;
}

/**
 * React Query mutation function for updating inbound package details.
 */
export const useManageUpdateInboundPackageMutation = ({
  onSuccessCallback,
}: IUseManageCreateOrUpdateMutation) => {
  const queryClient = useQueryClient();
  const {
    data,
    error,
    isError,
    isPending,
    mutate: updateInboundPackage,
    reset: resetUpdateInboundPackageMutation,
  } = useMutation({
    mutationKey: [MUTATE_UPDATE_INBOUND_PACKAGE],
    networkMode: 'always',
    mutationFn: INBOUND_API.updateInboundPackage,
    onSuccess: (data) => {
      onSuccessCallback?.(data);

      queryClient.invalidateQueries({
        queryKey: [PACKAGE_DETAILS_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [INBOUND_HISTORY_LIST_KEY],
      });
    },
  });

  return {
    data,
    error,
    isError,
    isPending,
    resetUpdateInboundPackageMutation,
    updateInboundPackage,
  };
};
